"use client";

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@repo/design-system/components/ui/skeleton";
import { useFilterSearch } from "@repo/design-system/hooks/use-filter-search";
import { useLocale } from "@repo/design-system/hooks/use-locale";
import { filterTypes as by } from "@repo/design-system/types/filter";
import dynamic from "next/dynamic";
import { env } from "~/setup/env";
import { useLanguage } from "~/translations/loader/use-language";
import { ClearFilters } from "../../filterbar/clear-filters";
import { GeoSelect } from "../../filterbar/filters/geo-select-eon";
import { GroupSelect } from "../../filterbar/filters/group-select-eon";
import { LocationSelect } from "../../filterbar/filters/location-select-eon";
import { MultiSelect } from "../../filterbar/filters/multi-select";
import { Searchbar } from "../../filterbar/searchbar-eon";
import { ToggleMap } from "../../filterbar/toggle-map-eon";
import { NewsletterFilterbarEonUk } from "../../newsletter/newsletter-filterbar-eon-uk";
import { NewsletterModal } from "../../newsletter/newsletter-modal-eon";
const WatchJobs = dynamic(() => import("../../filterbar/watch-jobs-eon").then(m => m.WatchJobs), {
  ssr: false,
  loading: () => <Skeleton className="h-12" />
});
export default function FilterbarEonUk() {
  const $ = _c(31);
  const t = useLanguage();
  const locale = useLocale();
  const {
    data
  } = useFilterSearch();
  const totalHits = data?.pages[0].totalHits ?? 0;
  const tagline = totalHits === 1 ? t.filterbar_taglineSingular : t.filterbar_tagline;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      backgroundImage: `url(${env.NEXT_PUBLIC_ASSET_URL}images/jobboard/filterbar_pattern.png)`,
      backgroundSize: "cover",
      backgroundPosition: "center"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== locale || $[2] !== totalHits) {
    t1 = totalHits.toLocaleString(locale);
    $[1] = locale;
    $[2] = totalHits;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1 || $[5] !== tagline) {
    t2 = <div className="grid grid-flow-row md:grid-flow-col"><h1 className="font-bold text-5xl md:mb-2"><span>{t1} {tagline} E.ON UK</span></h1></div>;
    $[4] = t1;
    $[5] = tagline;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t.aria_header_filterbar) {
    t3 = <h2 className="sr-only">{t.aria_header_filterbar}</h2>;
    $[7] = t.aria_header_filterbar;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Searchbar />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t.filterbar_geosearch_label) {
    t5 = <div className="grid grid-flow-row items-center gap-x-4 gap-y-4 md:grid-cols-2">{t4}<GeoSelect label={t.filterbar_geosearch_label} /></div>;
    $[10] = t.filterbar_geosearch_label;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [by.EMPLOYMENT_TYPE, by.CONTRACT];
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t.filterbar_filter3_placeholder) {
    t7 = <GroupSelect filterBy={t6} id="3" label={t.filterbar_filter3_placeholder} />;
    $[13] = t.filterbar_filter3_placeholder;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [by.REMOTE];
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t.filterbar_filter7_placeholder) {
    t9 = <MultiSelect filterBy={t8} id="7" label={t.filterbar_filter7_placeholder} />;
    $[16] = t.filterbar_filter7_placeholder;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t.filterbar_filter1_placeholder) {
    t10 = <LocationSelect id="6" label={t.filterbar_filter1_placeholder} />;
    $[18] = t.filterbar_filter1_placeholder;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ClearFilters className="xl:col-start-4" />;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t7 || $[23] !== t9) {
    t12 = <div className="grid grid-flow-row items-center gap-x-4 gap-y-4 md:grid-cols-2 xl:grid-cols-4">{t7}{t9}{t10}{t11}</div>;
    $[21] = t10;
    $[22] = t7;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="grid h-auto grid-flow-row grid-cols-1 gap-x-4 gap-y-4 text-lg md:grid-cols-2 xl:grid-cols-4"><WatchJobs /><NewsletterModal filterbarComponent={NewsletterFilterbarEonUk} /><ToggleMap /></div>;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t2 || $[28] !== t3 || $[29] !== t5) {
    t14 = <section className="outer-container grid justify-items-center py-container text-lg text-primary-foreground" id="filterbar" style={t0} tabIndex={-1}><div className="inner-container grid gap-y-4">{t2}{t3}{t5}{t12}{t13}</div></section>;
    $[26] = t12;
    $[27] = t2;
    $[28] = t3;
    $[29] = t5;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
}